// Centralised unit name/role lookup used across all screens
export const UNIT_DISPLAY = {
    bastion: { name: "BASTION", role: "tank", roleLabel: "Tank", roleDesc: "soaks damage · slow but hard to kill", desc: "Frontline defender. Absorbs damage and shields allies at low HP.", skill: "Shield Wall — absorbs incoming hits for 2 ticks" },
    raze: { name: "RAZE", role: "striker", roleLabel: "Striker", roleDesc: "burst DPS · fastest unit · fragile", desc: "High-speed burst damage. Targets the weakest enemy first.", skill: "Power Strike — 1.5× damage hit on lowest-HP target" },
    null_: { name: "NULL", role: "hacker", roleLabel: "Hacker", roleDesc: "disrupts · stuns · silences enemies", desc: "Disrupts enemies by locking down their highest-threat unit.", skill: "System Hack — stuns highest attack enemy for 1 tick" },
    pulse: { name: "PULSE", role: "support", roleLabel: "Support", roleDesc: "heals allies · boosts team skills", desc: "Keeps allies alive. Heals the most injured unit each turn.", skill: "Repair Pulse — full heal on most injured ally" },
};
export const ROLE_COLOR = {
    tank: "#f59e0b",
    striker: "#ef4444",
    hacker: "#8b5cf6",
    support: "#22c55e",
};
// Returns a formatted unit label. With slot: "BASTION-01". Without: "BASTION".
export function unitLabel(unitDefId, slot) {
    const name = UNIT_DISPLAY[unitDefId]?.name ?? unitDefId.toUpperCase();
    if (slot !== undefined)
        return `${name}-0${slot}`;
    return name;
}
// Extract slot from a battle ref like "p1_s2" → 2
export function slotFromRef(ref) {
    const m = ref.match(/_s(\d+)$/);
    return m ? parseInt(m[1]) : undefined;
}
